import React, { useEffect, useRef } from "react";
import { Box, Container, Typography } from "@mui/material";
import { toast } from "react-toastify";
import MailMagazinesTable from "../MailMagazinesTable";
import PaginatedListLayout from "../../../../shared/pagination/PaginatedListLayout";
import FrameCard from "../../../../shared/FrameCard";
import Schedule from "../Schedule";
import useMailMagazines from "../../../hooks/useMailMagazines";

export default function MailMagazinesIndexPage({ flashMessage }) {
  const { mailMagazines, loading, pagination, fetchMailMagazines } = useMailMagazines();

  const hasShownFlash = useRef(false);

  useEffect(() => {
    if (!flashMessage || hasShownFlash.current) return;
    hasShownFlash.current = true;
    const { message, type = "success" } =
      typeof flashMessage === "object" ? flashMessage : { message: flashMessage };
    (toast[type] || toast)(message);
  }, [flashMessage]);

  return (
    <>
      <Container sx={{ mt: 4, mb: 10, display: "flex", flexDirection: "column", gap: 5 }}>
        <FrameCard>
          <Box>
            <Typography variant="h5" fontWeight="bold" mb={1}>
              配信設定
            </Typography>
            <Schedule />
          </Box>
        </FrameCard>
        <FrameCard>
          <Box
            sx={{
              mx: -2,
              px: 2,
              pt: 1.5,
            }}
          >
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Typography variant="h5" fontWeight="bold">
                メルマガ一覧
              </Typography>
            </Box>
            <PaginatedListLayout
              items={mailMagazines}
              loading={loading}
              pagination={pagination}
              onPageChange={fetchMailMagazines}
              emptyText="メルマガデータがありません。"
            >
              <MailMagazinesTable rows={mailMagazines} />
            </PaginatedListLayout>
          </Box>
        </FrameCard>
      </Container>
    </>
  );
}
